import { render } from "./CampaignDetails.vue?vue&type=template&id=5158ad60&scoped=true"
import script from "./CampaignDetails.vue?vue&type=script&lang=js"
export * from "./CampaignDetails.vue?vue&type=script&lang=js"

import "./CampaignDetails.vue?vue&type=style&index=0&id=5158ad60&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5158ad60"]])

export default __exports__